import { createContext, useContext, useEffect, useState } from 'react';

// Fixed SAR pegged to USD: 1 USD = 3.75 SAR (standard fixed peg)
export const USD_TO_SAR = 3.75;

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  // Default currency is SAR per user requirement
  const [currency, setCurrency] = useState(() => localStorage.getItem('jw_currency') || 'SAR');

  useEffect(() => {
    localStorage.setItem('jw_currency', currency);
  }, [currency]);

  // convert a USD amount to selected currency
  const convert = (usd) => {
    if (usd == null) return 0;
    if (currency === 'SAR') return usd * USD_TO_SAR;
    return usd;
  };

  const symbol = currency === 'SAR' ? 'SAR' : '$';

  const format = (usd, opts = {}) => {
    const val = convert(usd);
    const digits = opts.digits ?? 2;
    if (currency === 'SAR') return `SAR ${val.toFixed(digits)}`;
    return `$${val.toFixed(digits)}`;
  };

  const toggle = () => setCurrency((c) => (c === 'SAR' ? 'USD' : 'SAR'));

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, toggle, convert, format, symbol, rate: USD_TO_SAR }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
